export class AbortResponseError extends Error {}
